import { WireFundsTable } from "../WireFundsTable";
import { DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutWireFundsProcessing extends Layout {
    horizontalspacer2: HorizontalSpacer;
    labelWireFundsProcessing: Label;
    layoutHoldWireFundsTable: WireFundsTable;
    layoutReadyWireFundsTable: WireFundsTable;
    layoutUnverifiedWireFundsTable: WireFundsTable;
    layoutVoidWireFundsTable: WireFundsTable;
    panelHeader: Panel;
    sourceUnpostedWire: DataSource;
    tabHold: Tab;
    tabReady: Tab;
    tabUnverified: Tab;
    tabVoid: Tab;
    tabsetMain: Tabset;
}
